import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogIn, Radio } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/admin" : "/matches");
    } catch (e2) {
      const d = e2.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen stadium-bg flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-lg bg-blue-600 flex items-center justify-center font-heading font-black text-2xl">CG</div>
          <div>
            <div className="font-heading text-2xl font-extrabold uppercase tracking-wider">Cricket Graphics <span className="text-blue-500">Studio</span></div>
            <div className="text-sm text-slate-400 flex items-center gap-2"><Radio size={14} className="text-red-500 animate-pulse"/> Live Broadcast Control Suite</div>
          </div>
        </div>

        <div className="glass rounded-2xl p-8 shadow-2xl">
          <h1 className="font-heading text-3xl font-extrabold uppercase mb-1">Sign In</h1>
          <p className="text-slate-400 text-sm mb-6">Access your broadcast control panel</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold uppercase text-slate-400 mb-2 tracking-wider">Email</label>
              <input data-testid="login-email-input" type="email" required value={email} onChange={e => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-lg bg-slate-800/70 border border-slate-700 focus:border-blue-500 focus:outline-none text-white" />
            </div>
            <div>
              <label className="block text-xs font-semibold uppercase text-slate-400 mb-2 tracking-wider">Password</label>
              <input data-testid="login-password-input" type="password" required value={password} onChange={e => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-lg bg-slate-800/70 border border-slate-700 focus:border-blue-500 focus:outline-none text-white" />
            </div>
            {err && <div data-testid="login-error" className="text-sm p-3 rounded-lg bg-red-500/10 border border-red-800 text-red-300">{err}</div>}
            <button type="submit" disabled={loading} data-testid="login-submit-button"
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-60 font-semibold uppercase tracking-wider">
              <LogIn size={18} /> {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
          <div className="mt-6 pt-5 border-t border-slate-800 text-xs text-slate-400">
            Don't have access? Contact your administrator to activate an account.
          </div>
        </div>
      </div>
    </div>
  );
}
